// Centralized site data + brand constants
export const BRAND = {
  name: "A SEVEN PACKERS AND MOVERS",
  shortName: "A Seven Packers & Movers",
  phone: "8826496656",
  whatsapp: "8826496656",
  address: "Om Vihar Phase 5, Near West Point School, Hastal Nawada Road, Uttam Nagar, New Delhi - 110059",
  area: "Delhi NCR",
  email: "info@asevenpackersandmovers.com",
};

export const telHref = `tel:+91${BRAND.phone}`;
export const waHref = (msg = "Hi, I would like a free quote for shifting services.") =>
  `https://wa.me/91${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const SERVICES = [
  {
    title: "Home Shifting",
    desc: "Saamaan ki safety ke saath aapke ghar ka complete shifting Delhi NCR me.",
    icon: "Home",
    color: "blue",
  },
  {
    title: "House Relocation",
    desc: "Door-to-door house relocation with packing, loading, transport & unpacking.",
    icon: "Truck",
    color: "orange",
  },
  {
    title: "Office Shifting",
    desc: "Minimum downtime ke saath office relocation. Documents & IT setup safe.",
    icon: "Building2",
    color: "red",
  },
  {
    title: "Office Furniture Shifting",
    desc: "Workstations, chairs, cabinets — dismantle, pack aur safely shift.",
    icon: "Armchair",
    color: "yellow",
  },
  {
    title: "Loading & Unloading",
    desc: "Trained labour for careful loading aur unloading at fair prices.",
    icon: "PackageCheck",
    color: "blue",
  },
  {
    title: "Packing & Unpacking",
    desc: "Bubble wrap, cartons, foam padding — har item ke liye sahi packing.",
    icon: "Package",
    color: "orange",
  },
  {
    title: "Furniture Relocation",
    desc: "Sofa, bed, almirah — heavy furniture dismantling & re-assembly.",
    icon: "Sofa",
    color: "red",
  },
  {
    title: "Commercial Goods Shifting",
    desc: "Shop, warehouse & commercial goods ki bulk shifting handle karte hain.",
    icon: "Warehouse",
    color: "yellow",
  },
  {
    title: "Delhi NCR Local Shifting",
    desc: "Delhi, Gurgaon, Noida, Ghaziabad, Faridabad — local shifting expert.",
    icon: "MapPin",
    color: "blue",
  },
];

export const WHY_US = [
  { title: "Safe & Secure", desc: "Quality packing material aur trained team.", icon: "ShieldCheck" },
  { title: "Experienced Team", desc: "Years of shifting expertise across Delhi NCR.", icon: "Users" },
  { title: "Affordable Pricing", desc: "Kaam dekh kar honest aur reasonable price.", icon: "BadgeIndianRupee" },
  { title: "On-Time Delivery", desc: "Time ki value — promised delivery, on time.", icon: "Clock" },
  { title: "Delhi NCR Coverage", desc: "Pura Delhi, Noida, Gurgaon, Faridabad, Ghaziabad covered.", icon: "Map" },
  { title: "24/7 Support", desc: "Hum aapke liye din ya raat available hain.", icon: "Headphones" },
];

export const GALLERY = [
  "https://images.pexels.com/photos/7464689/pexels-photo-7464689.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7203848/pexels-photo-7203848.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7217856/pexels-photo-7217856.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/4554242/pexels-photo-4554242.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7218504/pexels-photo-7218504.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/4246109/pexels-photo-4246109.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const HERO_IMAGE =
  "https://images.pexels.com/photos/20706506/pexels-photo-20706506.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const SAMPLE_REVIEWS = [
  {
    id: "seed-1",
    name: "Rohit Sharma",
    location: "Uttam Nagar, Delhi",
    rating: 5,
    message:
      "Bahut hi professional team hai. Mere 2BHK ka saamaan bina ek bhi scratch ke shift kar diya. Price bhi bilkul reasonable tha. Highly recommended!",
  },
  {
    id: "seed-2",
    name: "Priya Verma",
    location: "Noida Sector 62",
    rating: 5,
    message:
      "Office shifting was so smooth. Team came on time, packed everything carefully and unloaded with care. Best packers and movers in Delhi NCR.",
  },
  {
    id: "seed-3",
    name: "Anil Kumar",
    location: "Gurgaon",
    rating: 4,
    message:
      "Loading-unloading ka kaam bahut acche se kiya. Helpful staff and on-time delivery. Thoda aur careful ho sakte the with fragile items, but overall solid service.",
  },
  {
    id: "seed-4",
    name: "Sneha Gupta",
    location: "Dwarka, Delhi",
    rating: 5,
    message:
      "Furniture relocation karwaya, dismantling aur re-assembly dono perfect tha. Affordable pricing. A Seven team ka kaam dil khush kar diya!",
  },
];

export const SHIFTING_TYPES = [
  "Home Shifting",
  "House Relocation",
  "Office Shifting",
  "Office Furniture Shifting",
  "Loading & Unloading",
  "Packing & Unpacking",
  "Furniture Relocation",
  "Commercial Goods Shifting",
  "Delhi NCR Local Shifting",
];
